// Workspace → SMS number opt-in-proof uploader. On file select it runs the
// presigned three-step flow, then stores the verified key in the hidden
// opt_in_proof_key field the request form submits:
//   1. POST /workspace/{id}/sms-number/opt-in-proof/sign   → presigned PUT URL
//   2. PUT bytes directly to the presigned URL
//   3. POST /workspace/{id}/sms-number/opt-in-proof/commit → returns the key
// presigned_upload.js runs the requests.

import { onceGuard } from "./bind_once.js";
import { postForm, signAndPut } from "./presigned_upload.js";

const firstBind = onceGuard();

const ROOT_SELECTOR = "[data-sms-optin-upload]";
const FALLBACK_ERROR = "Could not upload the proof. Please try again.";

export function initSMSOptInProofUpload(root = document) {
  root.querySelectorAll(ROOT_SELECTOR).forEach(wireWidget);
}

function wireWidget(widget) {
  if (!firstBind(widget)) return;

  const input = widget.querySelector("[data-sms-optin-input]");
  const keyEl = widget.querySelector("[data-sms-optin-key]");
  const statusEl = widget.querySelector("[data-sms-optin-status]");
  const errorEl = widget.querySelector("[data-sms-optin-error]");
  const workspaceID = widget.dataset.workspaceId;
  if (!input || !keyEl || !workspaceID) return;

  const base = `/workspace/${workspaceID}/sms-number/opt-in-proof`;

  input.addEventListener("change", async () => {
    const file = input.files?.[0];
    if (!file) return;

    hide(errorEl);
    setStatus(statusEl, "Uploading…");
    input.disabled = true;

    try {
      const key = await uploadOne(file, base);
      keyEl.value = key;
      setStatus(statusEl, "Proof uploaded.");
    } catch (err) {
      console.error("sms opt-in proof upload failed", err);
      keyEl.value = "";
      hide(statusEl);
      showError(errorEl, err.userMessage || FALLBACK_ERROR);
    } finally {
      input.disabled = false;
      input.value = "";
    }
  });
}

async function uploadOne(file, base) {
  const signed = await signAndPut(`${base}/sign`, file);

  const committed = await postForm(`${base}/commit`, { key: signed.key });
  if (!committed.key)
    throw new Error("sms opt-in proof: commit answered no key");

  return committed.key;
}

function showError(el, message) {
  if (!el) return;
  el.textContent = message;
  el.classList.remove("hidden");
}

function hide(el) {
  if (!el) return;
  el.classList.add("hidden");
}

function setStatus(el, message) {
  if (!el) return;
  el.textContent = message;
  el.classList.remove("hidden");
}
